import i18n from '../i18n'; // or wherever your i18n instance is

export const getLocalizedPoiName = (poi) => {
  const lang = i18n.language || 'en';
  if (lang.startsWith('it') && poi.name_it) return poi.name_it;
  return poi.name_en || '';
};

export const getLocalizedPoiDescription = (poi) => {
  const lang = i18n.language || 'en';
  if (lang.startsWith('it') && poi.description_it) return poi.description_it;
  return poi.description_en || '';
};

export const getLocalizedPoiType = (poi) => {
  const lang = i18n.language || 'en';
  if (lang.startsWith('it') && poi.type_it) return poi.type_it;
  return poi.type_en || '';
};
